import request from '@/plugin/axios'

export function addOrUpdateFinaContr(obj) {
    return request({
        url: '/api/case/czFinancialContract/addOrUpdateFinaContr',
        method: 'post',
        data: obj
    })
}

export function updateFinancialContract(obj) {
    return request({
        url: '/api/case/czFinancialContract/updateFinancialContract',
        method: 'post',
        data: obj
    })
}

export function deleteFinancialContract(id) {
    return request({
        url: '/api/case/czFinancialContract/deleteFinancialContract/' + id,
        method: 'delete'
    })
}

